import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

const hardcoded = [
  { icon: '🙏', name: 'Sister Mary — Ooty', testimony: 'God healed me completely when the doctors had given up hope. The prayers of this church touched heaven, and I am a living testimony of His faithfulness!' },
  { icon: '✝', name: 'Brother Samuel — Fernhill', testimony: 'I came to Zion broken and lost. Through the Word of God and the love of this community, my family was completely restored. To God be the glory!' },
  { icon: '🌟', name: 'Sister Priya — Coonoor', testimony: 'The daily prayer meetings at Zion changed my life. I found peace, purpose, and the presence of God I had been searching for all my life.' },
];

export default function Testimonials() {
  const [dbApproved, setDbApproved] = useState([]);
  const [form, setForm] = useState({ name: '', phone: '', location: '', testimony: '' });
  const [status, setStatus] = useState('idle');

  const fetchApproved = async () => {
    const { data, error } = await supabase
      .from('testimonials')
      .select('name, location, testimony')
      .eq('status', 'approved')
      .order('created_at', { ascending: false });
    if (!error && data && data.length > 0) setDbApproved(data);
  };

  useEffect(() => {
    fetchApproved();
    const interval = setInterval(fetchApproved, 30000);
    return () => clearInterval(interval);
  }, []);

  // If DB has approved testimonials, show only DB ones. Otherwise show hardcoded.
  const allTestimonials = dbApproved.length > 0
    ? dbApproved
    : hardcoded;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.testimony.trim()) { alert('Please enter your name and testimony.'); return; }
    setStatus('sending');
    const { error } = await supabase.from('testimonials').insert([{
      name: form.name, phone: form.phone || null,
      location: form.location || null, testimony: form.testimony, status: 'pending',
    }]);
    if (!error) { setForm({ name: '', phone: '', location: '', testimony: '' }); setStatus('success'); }
    else { setStatus('error'); }
  };

  return (
    <section id="testimonials" className="section" style={{ background: 'linear-gradient(180deg,var(--bg-deep) 0%,var(--bg-dark) 100%)' }}>
      <div className="container">
        <div style={{ textAlign: 'center' }}>
          <span className="section-tag">✦ God's Faithfulness</span>
          <h2 className="section-title">Church <span>Testimonials</span></h2>
          <div className="divider center" />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))', gap: 20, marginBottom: 44 }}>
          {allTestimonials.map((t, i) => (
            <div key={i} className="card fade-up" style={{ padding: '30px 28px', position: 'relative' }}>
              <div style={{ position: 'absolute', top: -8, left: 18, fontFamily: "'Crimson Pro',serif", fontSize: '5.5rem', color: 'rgba(201,168,76,0.1)', lineHeight: 1, pointerEvents: 'none' }}>"</div>
              <div style={{ width: 58, height: 58, borderRadius: '50%', border: '2px solid var(--primary)', marginBottom: 16, background: 'rgba(201,168,76,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem' }}>
                {t.icon || '✝'}
              </div>
              <p style={{ fontFamily: "'Crimson Pro',serif", fontStyle: 'italic', fontSize: '1rem', color: 'var(--text-muted)', lineHeight: 1.7, marginBottom: 16 }}>{t.testimony}</p>
              <div style={{ fontSize: '0.75rem', fontWeight: 700, color: 'var(--primary)', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
                {t.name}{t.location ? ` — ${t.location}` : ''}
              </div>
            </div>
          ))}
        </div>
        {/* Submit form */}
        <form onSubmit={handleSubmit} style={{ maxWidth: 620, margin: '0 auto', background: 'var(--card-bg)', border: '1px dashed rgba(201,168,76,0.3)', borderRadius: 18, padding: '40px 36px' }}>
          <h3 style={{ fontFamily: "'Cinzel Decorative',serif", fontSize: '1rem', color: 'var(--primary)', marginBottom: 8, textAlign: 'center' }}>✦ Share Your Testimony</h3>
          <p style={{ fontFamily: "'Crimson Pro',serif", fontStyle: 'italic', color: 'var(--text-muted)', textAlign: 'center', marginBottom: 28, fontSize: '0.95rem' }}>Your story could inspire someone today!</p>
          {status === 'success' && <div style={{ background: 'rgba(201,168,76,0.12)', border: '1px solid rgba(201,168,76,0.4)', borderRadius: 12, padding: '16px 20px', marginBottom: 24, textAlign: 'center', color: 'var(--primary-light)', fontFamily: "'Crimson Pro',serif" }}>🙏 Thank you! Your testimony has been received and will be published after review. To God be the glory!</div>}
          {status === 'error' && <div style={{ background: 'rgba(178,34,34,0.12)', border: '1px solid rgba(178,34,34,0.4)', borderRadius: 12, padding: '16px 20px', marginBottom: 24, textAlign: 'center', color: '#ff8a8a' }}>❌ Something went wrong. Please try again.</div>}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }} className="te-form-row">
            <div className="form-group" style={{ margin: 0 }}><label>Your Name *</label><input type="text" placeholder="Your full name" value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} required /></div>
            <div className="form-group" style={{ margin: 0 }}><label>Phone (Optional)</label><input type="tel" placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={e=>setForm(f=>({...f,phone:e.target.value}))} /></div>
          </div>
          <div className="form-group"><label>Location (Optional)</label><input type="text" placeholder="e.g. Ooty, Coonoor…" value={form.location} onChange={e=>setForm(f=>({...f,location:e.target.value}))} /></div>
          <div className="form-group"><label>Your Testimony *</label><textarea placeholder="Share how God has worked in your life…" value={form.testimony} onChange={e=>setForm(f=>({...f,testimony:e.target.value}))} style={{ height: 150 }} required /></div>
          <button type="submit" className="btn-primary" style={{ width: '100%', marginTop: 8, opacity: status==='sending'?0.7:1 }} disabled={status==='sending'}>
            {status === 'sending' ? '⏳ Sending…' : 'Submit Testimony ✝'}
          </button>
          <p style={{ textAlign: 'center', fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: 14 }}>Your testimony will be reviewed before being published.</p>
        </form>
      </div>
      <style>{`@media(max-width:600px){ .te-form-row{ grid-template-columns:1fr !important; } }`}</style>
    </section>
  );
}
